module.exports = __webpack_public_path__ + "assets/img/Cumulative_tasks_bg.c3dd023f.png";